import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { AutoDiscoveryWizard } from '@/components/resources/AutoDiscoveryWizard';

/**
 * Standalone Auto Discover page. Renders the shared wizard without a preset
 * project, so step 0 shows the project picker (the user's own projects via
 * `useMyProjects`). Assign rights are enforced server-side (owner/admin).
 */
export default function ResourcesDiscoverPage() {
  const navigate = useNavigate();

  return (
    <Container size="xl">
      <PageHeader
        icon={<Sparkles size={22} />}
        title="Auto Discover resources"
        description="Gather existing domains and instances into a project by conditions."
      />
      <AutoDiscoveryWizard
        onClose={() => navigate('/projects')}
        onDone={() => navigate('/projects')}
      />
    </Container>
  );
}
